// for hanlp
const { hanlpClient, ckipClient, normalClient } = require('@/lib/axios')
/**
 * 與 ai service 溝通用的 module
 */
/**
 * @typedef {Object} ClosestResult
 * @property {number} similarity 最相似的句子的相似度(浮點數)
 * @property {number} index 最相似的句子位於list的索引值(index)
 * @property {Number[]} list 所有相似度的list
 */
module.exports = {
  /**
   * 將 word 跟 list 中的各個分別比對，找出相似度最高的選項
   * @param {string} word 要比對的文字
   * @param {string} list 數個被比對的選項
   * @returns {ClosestResult} ClosestResult
   */
  closest(word, list){
    return hanlpClient.post(`/closest`, {
      word,
      list
    }).then((res)=>res.data)
  },
  similarity(words){
    return hanlpClient.post(`/sim`, { words }).then((res)=>res.data)
  },
  postagging(article){
    return ckipClient.post('/postagging', { q: article }).then((res)=>res.data)
  },
  /**
   * 斷詞
   */
  segment(){
    // 斷詞 API
  },
  /**
   * 偵測反轉詞，並取出附近的詞
   * @param {*} query
   */
  privative(query){

  }
}
if(process.env.NODE_ENV !== 'production'){
  window.closest = module.exports.closest
  window.similarity = module.exports.similarity
  window.postagging = module.exports.postagging
}
